<ng-container *transloco="let t">
  <label *ngIf="label" [for]="formControlName"
    >{{ label }}
    <ng-container *ngIf="required"><span [class.required-color]="requiredColor">*</span></ng-container>
  </label>
  <div
    class="input-group"
    [class.is-invalid]="form.get(formControlName).invalid && (form.get(formControlName).dirty || form.get(formControlName).touched)"
  >
    <input
      [id]="formControlName"
      class="form-control"
      (click)="dp.toggle()"
      [placeholder]="placeholder && placeholder"
      [formControl]="getFormControl()"
      [minDate]="minDate"
      [maxDate]="maxDate"
      ngbDatepicker
      #dp="ngbDatepicker"
      type="text"
    />
    <div class="input-group-append">
      <span class="material-symbols-rounded text-black-50" (click)="dp.toggle()"> calendar_month </span>
    </div>
  </div>
  <div class="input-error-wrapper">
    <div
      class="input-error"
      *ngIf="form.get(formControlName).invalid && (form.get(formControlName).dirty || form.get(formControlName).touched)"
    >
      <div *ngIf="required && form.get(formControlName).errors.required">{{ formControlError }}</div>
      <div *ngIf="form.get(formControlName).errors.ngbDate?.invalid">{{ t('shared/invalidDate') }}</div>
    </div>
  </div>
</ng-container>
